import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import URLS from 'redux/urls'
import request from 'redux/utils/request'

export const fetchAllMessage = createAsyncThunk(
    'Message/fetchAllMessage',
    async (params, { rejectWithValue }) => {
        try {
            const response = await request('get', URLS.MESSAGE, params)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const addMessage = createAsyncThunk(
    'Message/addMessage',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await request('post', URLS.MESSAGE, payload)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const updateMessage = createAsyncThunk(
    'Message/updateMessage',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await request('patch', `${URLS.MESSAGE}/${payload.id}`, payload)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)
export const fetchOneMessage = createAsyncThunk(
    'Message/fetchOneMessage',
    async (id, { rejectWithValue }) => {
        try {
            const response = await request('get', `${URLS.MESSAGE}/${id}`)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const deleteMessage = createAsyncThunk(
    'Message/deleteMessage',
    async (id, { rejectWithValue }) => {
        try {
            const response = await request('delete', `${URLS.MESSAGE}/${id}`)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

const initialState = {
    loading: {
        query: false,
        mutation: false
    },
    filter: {
        q: ''
    },
    list: [],
    count: {},
    selected: {},
    selectedRows: []
}

const loadingReducer = (fieldName, status) => (state) => {
    state.loading[fieldName] = status
}

const startLoadingQuery = loadingReducer('query', true)
const stopLoadingQuery = loadingReducer('query', false)
const startLoadingMutation = loadingReducer('mutation', true)
const stopLoadingMutation = loadingReducer('mutation', false)

export const MessageSlice = createSlice({
    name: 'Message',
    initialState,
    reducers: {
        setAppliedSearchText: (state, action) => {
            state.filter.q = action.payload
        },
        setSelectedRows: (state, action) => {
            state.selectedRows = action.payload
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchAllMessage.pending, startLoadingQuery)
            .addCase(fetchAllMessage.fulfilled, (state, action) => {
                state.list = action.payload
                state.loading.query = false
            })
            .addCase(fetchAllMessage.rejected, stopLoadingQuery)
        builder
            .addCase(fetchOneMessage.pending, startLoadingQuery)
            .addCase(fetchOneMessage.rejected, stopLoadingQuery)
            .addCase(fetchOneMessage.fulfilled, (state, action) => {
                state.loading.query = false
                state.selected = action.payload
            })
        builder
            .addCase(updateMessage.pending, startLoadingQuery)
            .addCase(updateMessage.rejected, stopLoadingQuery)
            .addCase(updateMessage.fulfilled, (state, action) => {
                state.loading.query = false
                state.selected = action.payload
            })
        builder
            .addCase(deleteMessage.pending, startLoadingMutation)
            .addCase(deleteMessage.fulfilled, stopLoadingMutation)
            .addCase(deleteMessage.rejected, stopLoadingMutation)
    }
});


export const { setSelectedRows, setAppliedSearchText } = MessageSlice.actions;

export default MessageSlice.reducer;